module.exports = __webpack_public_path__ + "static/media/paso2.6a5bc863.png";